export default "__VITE_ASSET__CfKgAzds__"